import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'
import { isTokenExpired } from 'utils/isTokenExpired'
import { getTokenFromCookies, resetTokenFromCookies } from 'utils/tokenFromCookies'
import config, { loadConfig } from 'config'

// Lista de rotas públicas que não precisam de verificação de token
const PUBLIC_ROUTES = ['/permissao-token-contrato', '/visualizar-contrato']

const addAccessInterceptor = (apiInstance: AxiosInstance) => {
  apiInstance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const token = getTokenFromCookies()
      config.headers = config.headers || {}
      config.headers['X-NW-Sistema'] = 1
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config as any // eslint-disable-line @typescript-eslint/no-explicit-any
    },
    (error: AxiosError) => {
      return Promise.reject(error)
    }
  )
}

const addAuthInterceptor = (apiInstance: AxiosInstance) => {
  apiInstance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const token = getTokenFromCookies()
      config.headers = config.headers || {}
      config.headers['X-NW-Sistema'] = 1
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
        config.headers['X-NW-SessionId'] = ''
        config.headers['X-NW-Identificador'] = ''
        config.headers['X-NW-FormaAcesso'] = 'WW'
      }
      return config as any // eslint-disable-line @typescript-eslint/no-explicit-any
    },
    (error: AxiosError) => {
      return Promise.reject(error)
    }
  )
  apiInstance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const token = getTokenFromCookies()
      const isPublicRoute = PUBLIC_ROUTES.some((route) => config.url?.includes(route))

      if (token && !isPublicRoute) {
        if (isTokenExpired(token)) {
          resetTokenFromCookies()
          window.location.href = '/'
        }
      }
      return config as any // eslint-disable-line @typescript-eslint/no-explicit-any
    },
    (error: AxiosError) => {
      return Promise.reject(error)
    }
  )
}

const createApiInstances = async () => {
  await loadConfig()

  const IS_GATEWAY = config.GATEWAY_ACTIVE
  const api_acesso = axios.create({
    baseURL: IS_GATEWAY
      ? config.URL_API_GATEWAY + config.API_ACESSO
      : config.URL_API_LOCAL + config.API_ACESSO
  })
  addAccessInterceptor(api_acesso)

  const api_documentos = axios.create({
    baseURL: IS_GATEWAY
      ? config.URL_API_GATEWAY + config.API_DOCUMENTOS
      : config.URL_API_LOCAL + config.API_DOCUMENTOS
  })
  addAuthInterceptor(api_documentos)

  const api_dominios = axios.create({
    baseURL: IS_GATEWAY
      ? config.URL_API_GATEWAY + config.API_DOMINIOS
      : config.URL_API_LOCAL + config.API_DOMINIOS
  })
  addAuthInterceptor(api_dominios)

  const api_pessoas = axios.create({
    baseURL: IS_GATEWAY
      ? config.URL_API_GATEWAY + config.API_PESSOAS
      : config.URL_API_LOCAL + config.API_PESSOAS
  })
  addAuthInterceptor(api_pessoas)

  const api_simulacao_vendas = axios.create({
    baseURL: IS_GATEWAY
      ? config.URL_API_GATEWAY + config.API_SIMULACAO_VENDAS
      : config.URL_API_LOCAL + config.API_SIMULACAO_VENDAS
  })
  addAuthInterceptor(api_simulacao_vendas)

  const api_reports_getway = axios.create({
    baseURL: IS_GATEWAY
      ? config.URL_API_GATEWAY + config.API_REPORTS_GATEWAY
      : config.URL_API_LOCAL + config.API_REPORTS_GATEWAY
  })
  addAuthInterceptor(api_simulacao_vendas)

  const api_gateway = axios.create({
    baseURL: config.URL_API_GATEWAY
  })
  addAuthInterceptor(api_gateway)

  return {
    api_acesso,
    api_documentos,
    api_dominios,
    api_pessoas,
    api_simulacao_vendas,
    api_reports_getway,
    api_gateway
  }
}

const apiInstances = await createApiInstances()

export const {
  api_acesso,
  api_documentos,
  api_dominios,
  api_pessoas,
  api_simulacao_vendas,
  api_reports_getway,
  api_gateway
} = apiInstances
